import { CommonModule } from '@angular/common';
import { Component, HostListener, Input, OnDestroy, OnInit, input, output } from '@angular/core';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-filter-header',
  templateUrl: './filter-header.component.html',
  styleUrls: ['filter-header.component.scss'],
  imports: [CommonModule, ButtonModule],
})
export class FilterHeaderComponent implements OnInit, OnDestroy {
  colspan = input<number>(1);

  @Input()
  showMoreFiltersButton = false;

  @Input()
  showClearButton = false;

  @Input()
  showApplyButton = true;

  @Input()
  showMoreFilters = false;

  showMoreFiltersChange = output<boolean>();
  applyFilters = output();
  clearAllFilters = output();

  desktop: boolean = false;

  ngOnInit(): void {
    this.desktop = window.innerWidth >= 768;
    window.addEventListener('resize', this.onResize);
  }

  @HostListener('window:resize')
  onResize(): void {
    this.desktop = window.innerWidth >= 768;
  }

  ngOnDestroy(): void {
    window.removeEventListener('resize', this.onResize);
  }

  showAdvancedFilters() {
    this.showMoreFilters = !this.showMoreFilters;
    this.showMoreFiltersChange.emit(this.showMoreFilters);
  }

  clearFilters() {
    this.clearAllFilters.emit();
  }

  apply() {
    this.applyFilters.emit();
  }
}
